import { useEffect, useRef } from 'react';
import mitt from 'mitt';

// Create the event emitter but keep it private to this module
const emitter = mitt();

// hook that handles reference stability internally
function useEventBus(eventName, handler) {
  // Use useRef to store the latest handler without causing effect to re-run
  const handlerRef = useRef(handler);
  
  // Keep the ref current
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);
  
  useEffect(() => {
    // Create a stable callback that uses the current handler
    const stableHandler = (eventData) => {
      handlerRef.current(eventData);
    };
    
    // Subscribe using the stable wrapper
    emitter.on(eventName, stableHandler);
    
    // Cleanup function
    return () => {
      emitter.off(eventName, stableHandler);
    };
  }, [eventName]); // Only eventName is a dependency 
}

// Function to emit events
function emit(eventName, data) {
  emitter.emit(eventName, data);
}

export { useEventBus, emit };